// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6210) return "static/chunks/6210-a700a3fd6bbbc546.js";
	if (chunkId === 3471) return "static/chunks/3471-a5e8f9e7045df905.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2811":"8ccfdbcef422cd97","6023":"06b6d7d7a7e16553","7016":"880fc1ecf149ff4d"}[chunkId] + ".js";
};